import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { getColorShades } from "../@shared/utils/Utils";
import { useAuthStore } from "../@shared/store/useAuthStore";
import { levelXPTable } from "../@shared/utils/levelXPTable";
import { MainContext } from "../App";

export default function NeoMenuItem({
  icon,
  iconTop = false,
  isLevelBadge = false,
  isRounded = true,
  additionalStyle = {},
  label,
  onClick,
  disabled,
  endAdorn,
  redDot,
  isLocked,
}) {
  const { userData } = useAuthStore();
  const { Theme } = React.useContext(MainContext);
  const getColors = (color) => {
    if (color === "$primary" || color === "$secondary") {
      return {
        light: `${color}Active`,
        dark: `${color}Hover`,
        shadow: `${color}`,
      };
    }

    return getColorShades(color);
  };

  return (
    <Box
      sx={{
        ...additionalStyle,
        height: { xs: "26px", md: "32px" },
        maxWidth: { xs: "80px", md: "120px" },
        minWidth: { xs: "50px", md: "60px" },
        backgroundColor: "#1135b7",
        borderRadius: iconTop ? "5px" : "20px",
        paddingBottom: "3px",
        border: "3px solid #000",
        position: "relative",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {redDot && (
        <Box
          style={{
            position: "absolute",
            top: -5,
            right: -5,
            width: 14,
            height: 14,
            borderRadius: "10px",
            backgroundColor: "red",
            zIndex: 5,
            borderWidth: "3px",
          }}
        />
      )}
      <Box
        sx={{
          height: { xs: "18px", md: "20px" },
          width: iconTop ? "74%" : "85%",
          paddingTop: { xs: "2px", md: "4px" },
          paddingBottom: { xs: "2px", md: "4px" },
          paddingRight: iconTop ? "" : { xs: "2px", md: "4px" },
          px: iconTop ? "5px" : "",
          borderRadius: isRounded ? "20px" : "5px",
          backgroundColor: "#0070f7",
          borderTop: `3px solid ${getColors("#0070f7").light}`, // light highlight
          borderLeft: `3px solid ${getColors("#0070f7").light}`, // light highlight
          borderRight: `3px solid ${getColors("#0070f7").dark}`, // dark shadow
          borderBottom: `3px solid ${getColors("#0070f7").dark}`,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        {iconTop ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {isLevelBadge ? (
              <>
                {(() => {
                  const currentLevel = parseInt(userData.level || "1", 10);
                  const currentXP = userData.xp || 0;

                  const currentLevelData = levelXPTable.find(
                    (lvl) => parseInt(lvl.level, 10) === currentLevel
                  );
                  const nextLevelData = levelXPTable.find(
                    (lvl) => parseInt(lvl.level, 10) === currentLevel + 1
                  );

                  const xpIntoLevel =
                    currentXP - (currentLevelData?.cumulativeXP || 0);
                  const xpNeeded = nextLevelData
                    ? nextLevelData.cumulativeXP - currentLevelData.cumulativeXP
                    : 1;

                  const progressPercent = Math.min(
                    100,
                    Math.max(0, Math.round((xpIntoLevel / xpNeeded) * 100))
                  );

                  return (
                    <>
                      <div
                        style={{
                          width: "100%",
                          height: "6px",
                          borderRadius: "10px",
                          border: "2px solid #000",
                          backgroundColor: Theme.palette.text.main,
                          zIndex: 30,
                          marginTop: 10,
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            width: `${progressPercent}%`,
                            backgroundColor: Theme.palette.border.dark,
                            transition: "width 0.3s ease-in-out",
                          }}
                        />
                      </div>
                      <Typography
                        sx={{
                          width: "100%",
                          textAlign: "center",
                          fontWeight: 900,
                          fontSize: 8,
                          color: "#fff",
                          textShadow: ` -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000`,
                          zIndex: 31,
                          marginTop: "-5px",
                        }}
                      >
                        {progressPercent}%
                      </Typography>
                    </>
                  );
                })()}
              </>
            ) : (
              <Typography
                sx={{
                  width: "100%",
                  textAlign: "center",
                  fontWeight: 900,
                  fontSize: isLevelBadge ? 8 : { xs: 12, md: 14 },
                  color: "#fff",
                  textShadow: ` -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000`,
                  zIndex: 31,
                  marginTop: isLevelBadge ? "-5px" : "",
                }}
              >
                {/* percentage value */}
                {label}
              </Typography>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              minWidth: "60%",
              height: "100%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              position: "relative",
              backgroundColor: "rgb(255, 237, 186)",
              borderRadius: "20px",
              paddingRight: "5px",
              paddingLeft: "5px",
              textAlign: "right",
            }}
          >
            <Typography
              sx={{
                paddingLeft: { xs: "10px", md: "20px" },
                fontWeight: 900,
                fontSize: { xs: 12, md: 14 },
                color: "#16116e",
              }}
            >
              {label}
            </Typography>
          </Box>
        )}

        {endAdorn}
      </Box>
      <img
        src={icon}
        style={{
          height: isLevelBadge ? 60 : 42,
          width: "auto",
          position: "absolute",
          left: iconTop ? "52%" : -15,
          top: isLevelBadge ? "-95%" : iconTop ? "-60%" : "-10%",
          transform: iconTop ? "translate(-50%, 0%)" : "",
        }}
      />
      {isLevelBadge && (
        <Typography
          sx={{
            position: "absolute",
            top: "-10%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: { xs: "12px", md: "18px" },
            fontWeight: "bold",
            color: "#fff",
            textShadow: ` -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  3px 0 #000`,
          }}
        >
          {userData.level}
        </Typography>
      )}
      {isLocked && (
        <img
          src={require("../@shared/assets/icons/lock_deck_icon2.png")}
          style={{
            width: 30,
            height: 30,
            position: "absolute",
            right: "-10%",
            top: "0%",
            transform: iconTop ? "translate(0%, -50%)" : "",
            zIndex: 10,
          }}
        />
      )}
    </Box>
  );
}
